import { ArrayField, Datagrid, SelectInput, TextField } from 'ra-ui-materialui'
import React from 'react'
import { professionalSpecialTypeChoices } from 'services/cfg/form'
import { CustomFormProps } from 'types/common'
import CatalogItemBaseForm from 'ui-shared/Forms/CatalogItemBaseForm'

const ProfessionalSectionForm: React.FC<CustomFormProps> = (props) => (
  <CatalogItemBaseForm {...props}>
    <SelectInput
      source="specialType"
      choices={professionalSpecialTypeChoices}
      resettable
    />

    <ArrayField sortable={false} source="productsFull">
      <Datagrid>
        <TextField source="name" />
      </Datagrid>
    </ArrayField>
  </CatalogItemBaseForm>
)

export default ProfessionalSectionForm
